module.exports = __webpack_public_path__ + "static/media/CustomerLove.3b45a75f.png";